import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './lineups.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/icons/icons'
import {Match, Team} from '../../models'
import {sortPlayers} from '../../services/positions'
import getState from '../../services/event-state'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('team', Team)
@Attribute('bench', Boolean)
@Attribute('goalkeeper', Boolean)
@Attribute('not-goalkeeper', Boolean)
export default class Lineups extends HTMLElement {
  select(lineup) {
    getState(this.match).assignPlayer(lineup)
  }
  attached() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }
  matchChange() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }
  teamLineup() {
    const on = {}
    const lineups = (this.lineups || [])
      .filter(lineup => lineup.player)
      .filter(lineup => lineup.team === this.team)
      .filter(l => ~['confirmed', 'bench'].indexOf(l.status))
    const event = this.state.event
    const events = (this.events || [])
      .filter(e => event.seconds > e.seconds)
    lineups.forEach(lineup => {
      on[lineup.playerId] = !lineup.isBench
    })
    events.forEach((event) => {
      switch(event.name) {
        case 'substitution_1': // Swap out
        case 'red_card':
          if(this.sport !== 'e_football') {
            on[event.playerId] = false
          }
          break
        case 'substitution_0': // Swap in
          on[event.playerId] = true
          break
      }
    })

    return (lineups || [])
      .filter(lineup => this.bench !== on[lineup.playerId])
      .filter(lineup => {
        if(this.goalkeeper) return lineup.player.position === 'goalkeeper'
        if(this.notGoalkeeper) return lineup.player.position !== 'goalkeeper'
        return true
      })
      .sort((a, b) => {
        return ((a.batch || Infinity) - (b.batch || Infinity)) ||
          sortPlayers(a.player, b.player, null, this.sport)
      })
  }
  playtime(lineup) {
    if(lineup.duration) return Math.ceil(lineup.duration / 60)
    var on = !lineup.isBench
    var total = 0
    var current = 0
    var events = lineup.events.sort((a, b) => a.seconds - b.seconds)
    for(var event of events) {
      // Swapped in
      if(!on && event.name === 'substitution_0') {
        current = event.seconds
        on = true
      }
      // Swapped out
      if(on && event.name === 'substitution_1') {
        total += event.seconds - current
        current = event.seconds
        on = false
      }
      if(on && event.name === 'red_card') {
        return Math.ceil((total + event.seconds - current) / 60)
      }
    }
    if(on) total += this.match.duration * 60 - current
    return Math.ceil(total / 60)
  }
  status(lineup) {
    if(!lineup.isBench) return 'started'
    if(this.bench) return 'substitute'
    return 'subbed'
  }
  playerClass(player, index) {
    return {
      active: (this.state.event.player === player.player) && (player.batch === this.state.event.batch),
      'sub-active': this.state
        .subEvents
        .find(e => (e.player === player.player) && (e.batch === player.batch) ),
    }
  }
  eventsFor(lineup) {
    var ret = {}
    lineup.events
      .filter(event => event.isValid)
      .forEach(event => {
        ret[event.icon] = true
      })
    return Object.keys(ret)
  }

  get sport() {
    return this.match && this.match.sport
  }

  get showShirt() {
    return ![
      'cricket',
      'rugby_union',
      'e_football',
      'csgo',
      'lol'
    ].includes(this.sport)
  }

  get state() {
    return getState(this.match)
  }
}
